
export default class SignInResponseModel {
    public givenName: string = '';
    public surname: string = '';
    public jwt: string = '';
    public jwtExpirationMs: number = 0;
    public firstTimeSigningIn: boolean = false;
}
